// Theme wordmark resolution. Assets may be `{ url }` objects or
// legacy bare URL strings. Dark mode uses `logoDark` when one is
// uploaded; otherwise the main logo is used in both modes.

export const resolveAssetUrl = (asset) =>
  (typeof asset === "string" && asset) ||
  (asset && typeof asset === "object" && asset.url) ||
  "";

export const resolveThemeWordmarkUrl = (theme = {}, { mode } = {}) => {
  const darkUrl = resolveAssetUrl(theme?.logoDark);
  if (mode === "dark" && darkUrl) return darkUrl;
  return (
    resolveAssetUrl(theme?.logo) ||
    resolveAssetUrl(theme?.logoSymbol) ||
    resolveAssetUrl(theme?.enterprise?.logo) ||
    ""
  );
};
